<!--
 * @Description: Description
 * @Author: wning
 * @Date: 2022-11-30 17:30:43
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-12 18:10:55
-->
<template>
  <div class="x-data-back">
    <div class="x-data-header">
      <slot name="header"></slot>
    </div>
    <div class="x-data-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'XBack'
  }
</script>

<style lang="scss" scoped>
  .x-data-back {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin-top: 10px;

    // padding: 24px 32px;
    border: 1px solid #ebebeb;
    background-color: #fff;
    box-shadow: 5px 12px 12px 0 rgb(0 0 0 / 10%);

    .x-data-header {
      font-family: 'PingFang SC-Medium', 'PingFang SC', sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 45px;
      box-sizing: border-box;
      width: 100%;
      height: 45px;
      padding-left: 20px;
      color: #171c26;
      border-radius: 3px 3px 0 0;
      background: rgb(8 26 81 / 10%);
    }

    .x-data-box {
      padding: 16px;

      // display: flex;
      // overflow: hidden;
      // flex: 1;
      // flex-direction: column;
      // height: 0;
    }
  }
</style>
